import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { Localiser } from './services/localiser';
import { Navigation } from './services/navigation.service';
import { UserService } from './services/user.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { LoginComponent } from './components/login/login.component';
import { MenuComponent } from './components/menu/menu.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { HomeAteneoComponent } from './components/home-ateneo/home-ateneo.component';
import { LocationsComponent } from './components/locations/locations.component';
import { AirfalComponent } from './components/airfal/airfal.component';
import { FloorplansComponent } from './components/floorplans/floorplans.component';
import { DevicesComponent } from './components/devices/devices.component';
import { IndicatorsComponent } from './components/indicators/indicators.component';
import { IndicatorsSelectionComponent } from './components/indicators/indicators-selection/indicators-selection.component';
import { WarningsComponent } from './components/warnings/warnings.component';
import { CookieService} from 'ng2-cookies';
import { HomeConfigurationComponent } from './components/home-configuration/home-configuration.component';
import { UsersComponent } from './components/users/users.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ChangeProjectComponent } from './components/users/change-project/change-project.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { ReglasComponent } from './components/reglas/reglas.component';
import { NewReglaComponent } from './components/reglas/new-regla/new-regla.component';
import { NewProyectoComponent } from './components/users/new-proyecto/new-proyecto.component';
import { NewEmpresaComponent } from './components/users/new-empresa/new-empresa.component';
import { NewUserComponent } from './components/users/new-user/new-user.component';
import { ProfileComponent } from './components/profile/profile.component';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { DeleteReglaComponent } from './components/reglas/delete-regla/delete-regla.component';
import { FadeComponent } from './components/fade/fade.component';
import { ListaFadesComponent } from './components/fade/lista-fades/lista-fades.component';
import { ListaGruposComponent } from './components/fade/lista-grupos/lista-grupos.component';
import { SelectFloorplanComponent } from './components/select-floorplan/select-floorplan.component';
import { ContactMessageComponent } from './components/contact-message/contact-message.component';
import { EditComponent } from './components/devices/edit/edit.component';
import { AlertsComponent } from './components/alerts/alerts.component';
import { LimitsComponent } from './components/limits/limits.component';
import { EditConcentradorComponent } from './components/devices/edit-concentrador/edit-concentrador.component';
import { EditSensorComponent } from './components/devices/edit-sensor/edit-sensor.component';
import { ZonesComponent } from './components/zones/zones.component';
import { NewZoneComponent } from './components/zones/new-zone/new-zone.component';
import { DeleteZoneComponent } from './components/zones/delete-zone/delete-zone.component';
import { InfoZoneComponent } from './components/zones/info-zone/info-zone.component';
import { InfoGruposComponent } from './components/fade/lista-grupos/info-grupos/info-grupos.component';
import { InfoFadesComponent } from './components/fade/lista-fades/info-fades/info-fades.component';
import { OtaComponent } from './components/ota/ota.component';
import { IndicatorsPresencesComponent } from './components/indicators/indicators-presences/indicators-presences.component';
import { IndicatorsSensorsComponent } from './components/indicators/indicators-sensors/indicators-sensors.component';
import { DeleteUserComponent } from './components/users/delete-user/delete-user.component';
import { ResetPasswordComponent } from './components/users/reset-password/reset-password.component';
import { UploadComponent } from './components/select-floorplan/upload/upload.component';
import { AutotestComponent } from './components/autotest/autotest.component';
import { WarningComponent } from './components/autotest/warning/warning.component';
import { ReportsComponent } from './components/reports/reports.component';
import { SelectionPrintComponent } from './components/reports/selection-print/selection-print.component';
import { ConfigureComponent } from './components/reports/configure/configure.component';
import { DeleteFloorplanComponent } from './components/select-floorplan/delete-floorplan/delete-floorplan.component';
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { DeleteComponent } from './components/devices/delete/delete.component';
import { MatTooltipModule } from "@angular/material/tooltip";
import { OptionsComponent } from './components/devices/options/options.component';
import { ParametersComponent } from './components/parameters/parameters.component';
import { ImageOptionsComponent } from './components/floorplans/image-options/image-options.component';
import {MatGridListModule} from "@angular/material/grid-list";
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatInputModule} from '@angular/material/input';
import {DeleteProjectComponent} from './components/users/delete-project/delete-project.component';
import {DeleteCompanyComponent} from './components/users/delete-company/delete-company.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    MenuComponent,
    HomeAteneoComponent,
    LocationsComponent,
    AirfalComponent,
    FloorplansComponent,
    DevicesComponent,
    IndicatorsComponent,
    IndicatorsSelectionComponent,
    WarningsComponent,
    HomeConfigurationComponent,
    UsersComponent,
    ChangeProjectComponent,
    ReglasComponent,
    NewReglaComponent,
    NewProyectoComponent,
    NewEmpresaComponent,
    NewUserComponent,
    ProfileComponent,
    DeleteReglaComponent,
    FadeComponent,
    ListaFadesComponent,
    ListaGruposComponent,
    SelectFloorplanComponent,
    ContactMessageComponent,
    EditComponent,
    AlertsComponent,
    LimitsComponent,
    EditConcentradorComponent,
    EditSensorComponent,
    ZonesComponent,
    NewZoneComponent,
    DeleteZoneComponent,
    InfoZoneComponent,
    InfoGruposComponent,
    InfoFadesComponent,
    OtaComponent,
    IndicatorsPresencesComponent,
    IndicatorsSensorsComponent,
    DeleteUserComponent,
    ResetPasswordComponent,
    UploadComponent,
    AutotestComponent,
    WarningComponent,
    ReportsComponent,
    SelectionPrintComponent,
    ConfigureComponent,
    DeleteFloorplanComponent,
    DeleteComponent,
    OptionsComponent,
    ParametersComponent,
    ImageOptionsComponent,
    OnlyNumbersDirective,
    DeleteProjectComponent,
    DeleteCompanyComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,

    // Angular Material
    MatFormFieldModule,
    MatSelectModule,
    MatExpansionModule,
    MatDialogModule,
    MatCheckboxModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatGridListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,

    BrowserAnimationsModule
  ],
  providers: [
    // Servicios
    Localiser,
    Navigation,
    UserService,
    CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
